<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入订单号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.username" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.sex" @keyup.enter.native="clicksearch" placeholder="请输入性别" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.salechannel" @keyup.enter.native="clicksearch" placeholder="请输入销售渠道" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.consignee" @keyup.enter.native="clicksearch" placeholder="请输入收货人" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入手机号码" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.consigneeaddress" @keyup.enter.native="clicksearch" placeholder="请输入收货地址" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="info" @click="backStoreOwner">返回</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Orderid" label="订单号" min-width="10%"></el-table-column>
          <el-table-column prop="Jigouname" label="机构名称" min-width="6%"></el-table-column>
          <el-table-column prop="Username" label="姓名" min-width="6%"></el-table-column>
          <el-table-column prop="Sex" label="性别" min-width="5%"></el-table-column>
          <el-table-column prop="Age" label="年龄" min-width="5%"></el-table-column>
          <el-table-column prop="Glassestime" label="配镜时间" min-width="6%"></el-table-column>
          <el-table-column prop="Consignee" label="收货人" min-width="6%"></el-table-column>
          <el-table-column prop="Phone" label="手机号码" min-width="6%"></el-table-column>
          <el-table-column prop="Consigneeaddress" label="收货地址" min-width="6%"></el-table-column>
          <el-table-column prop="Optometrytime" label="验光日期" min-width="6%"></el-table-column>
          <el-table-column prop="Remarks" label="备注" min-width="6%"></el-table-column>
          <el-table-column prop="Optometryname" label="验光师" min-width="6%"></el-table-column>
          <el-table-column prop="Amount" label="代理商金额" min-width="6%"></el-table-column>
          <el-table-column prop="Amountretail" label="零售金额" min-width="6%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="7%"></el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->
  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyOptometristYuFuKuanOut',
  data () {
    return {
      activeName: 'first',
      addForm: {
        name: '',
        phone: '',
        school: '',
        grade: '',
        idnumber: ''
      },
      editForm: {
        id: '0',
        name: '',
        phone: '',
        school: '',
        grade: '',
        idnumber: ''
      },
      sendForm: {
        orderid: '',
        trackingname: '',
        trackingnumber: ''
      },
      // 查询
      keywords: {
        orderid: '',
        jigouid: '-1',
        jigouname: '',
        username: '',
        sex: '',
        salechannel: '',
        consignee: '',
        phone: '',
        consigneeaddress: '',
        orderstatus: '-1',
        isyufukuan: '1'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.keywords.jigouid = parentdata.params.jigouid,
      this.apiOptometristYuFuKuanOutNum()
      this.apiOptometristYuFuKuanOutList()
    },
    backStoreOwner () {
      this.$emit('triggerFunc', '')
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiOptometristYuFuKuanOutNum()
      this.apiOptometristYuFuKuanOutList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiOptometristYuFuKuanOutList()
    },
    apiOptometristYuFuKuanOutNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        jigouid: that.keywords.jigouid,
        username: that.keywords.username,
        sex: that.keywords.sex,
        salechannel: that.keywords.salechannel,
        consignee: that.keywords.consignee,
        phone: that.keywords.phone,
        consigneeaddress: that.keywords.consigneeaddress,
        orderstatus: that.keywords.orderstatus,
        isyufukuan: that.keywords.isyufukuan
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_OptometristYuFuKuanOutNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiOptometristYuFuKuanOutList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        orderid: that.keywords.orderid,
        jigouid: that.keywords.jigouid,
        username: that.keywords.username,
        sex: that.keywords.sex,
        salechannel: that.keywords.salechannel,
        consignee: that.keywords.consignee,
        phone: that.keywords.phone,
        consigneeaddress: that.keywords.consigneeaddress,
        orderstatus: that.keywords.orderstatus,
        isyufukuan: that.keywords.isyufukuan
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_OptometristYuFuKuanOutList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
